<template>
    <div>
        <div class="subtitle">
            <h6>Upcoming Events</h6>
        </div>
        <div class="desc">
            <ul>
                <li v-for="event in upComingEventList" :key="event.EventID">
                    <i class="fa fa-bullhorn" aria-hidden="true"></i>
                    <div class="feed-event-item">
                        <strong>
                            {{event.EventTitle}}
                        </strong>
                        <span>
                            {{event.EventStartTimeConvert}} - {{event.EventEndTimeConvert}}
                        </span>
                    </div>
                    <a @click="FeedViewEvent(event.EventID)">View</a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    import DataSource from "../../data/datasource";

    export default {
        name: "Feed_Upcoming_Component",
        data() {
            return {
                upComingEventList: [],
            };
        },
        mounted() {
            this.LoadUpComingEvent();
        },
        props: [],
        methods: {
            async LoadUpComingEvent() {
                try {
                    const response = DataSource.shared.getUpComingEvent();
                    response.then((response) => {

                        if (response.code === '2') {
                            console.log('No record found');
                        } else if (response.code === '99') {
                            console.log('99');
                        } else {
                            this.upComingEventList = (response.Table) ? response.Table : [];
                        }
                    });
                } catch (e) {
                    console.log(e);
                }
            },
            FeedViewEvent(EventID) {
                this.$router.push('event?id=' + EventID);
            }
        },

    };
</script>
<style scoped>
    .sideBarSection__item .desc ul {
        margin-top: 10px;
    }

    .feed-event-item span {
        display: block;
    }

    .feed-event-item a {
        font-size: 0.7em !important;
        font-weight: normal;
    }

    .sideBarSection__item .desc li a {
        font-size: 0.8em;
        font-weight: normal;
        display: block;
        margin-left: auto;
        background: #007bff;
        padding: 5px;
        border-radius: 5px;
        color: #fff;
        opacity: 0;
        transition: all 0.3s ease-in-out;
        cursor: pointer;
    }

    .sideBarSection__item .desc li:hover a {
        opacity: 1;
    }

    .sideBarSection__item .desc li:hover strong {
        color: #007bff;
    }
</style>
<style>
</style>